import classNames from "classnames";
import React from "react";
import { Icon } from "rhombus-react";

export default function ImposiumAction(props) {
	const { url, tooltipContent, isDisabled } = props;
	const className = classNames(
		"action-link",
		"cypress-imposium-open-in-imposium-action",
		{ "is-disabled": isDisabled }
	);

	return (
		<a
			className={className}
			data-tip={tooltipContent}
			href={url}
			target="_blank"
		>
			<span>
				<Icon
					className="bounce-circle"
					name="far fa-paintbrush-pencil"
				/>
			</span>
		</a>
	);
}
